import { Action } from 'redux';
import { OpsTask, OpsTaskListResult, OpsTasksCounts, OpsTasksFilters, OpsTaskStatusId } from 'model/OpsTask';

//Action Types
export const OPS_TASKS_RESET_ACTION_TYPE = 'opsTasks/reset';
export const OPS_TASKS_FETCH_START_ACTION_TYPE = 'opsTasks/fetch_start';
export const OPS_TASKS_FETCH_SUCCESS_ACTION_TYPE = 'opsTasks/fetch_success';
export const OPS_TASKS_FETCH_COUNTS_SUCCESS_ACTION_TYPE = 'opsTasks/fetch_counts_success';
export const OPS_TASKS_SAVE_START_ACTION_TYPE = 'opsTasks/save_start';
export const OPS_TASKS_SAVE_SUCCESS_ACTION_TYPE = 'opsTasks/save_success';
export const OPS_TASKS_DELETE_START_ACTION_TYPE = 'opsTasks/delete_start';
export const OPS_TASKS_DELETE_SUCCESS_ACTION_TYPE = 'opsTasks/delete_success';
export const OPS_TASKS_UPDATE_STATUS_START_ACTION_TYPE = 'opsTasks/update_status_start';
export const OPS_TASKS_UPDATE_STATUS_SUCCESS_ACTION_TYPE = 'opsTasks/update_status_success';
export const OPS_TASKS_BULK_COMPLETE_START_ACTION_TYPE = 'opsTasks/bulk_complete_start';
export const OPS_TASKS_BULK_COMPLETE_SUCCESS_ACTION_TYPE = 'opsTasks/bulk_complete_success';
export const OPS_TASKS_ERROR_ACTION_TYPE = 'opsTasks/error';

//Actions
type OpsTasksResetAction = Action<typeof OPS_TASKS_RESET_ACTION_TYPE>;

// fetch_start records the filters/pagination used so mutations can reconcile list + counts later.
interface OpsTasksFetchStartAction extends Action<typeof OPS_TASKS_FETCH_START_ACTION_TYPE> {
    payload: {
        filters: OpsTasksFilters;
        page: number;
        size: number;
    };
}

interface OpsTasksFetchSuccessAction extends Action<typeof OPS_TASKS_FETCH_SUCCESS_ACTION_TYPE> {
    payload: {
        result: OpsTaskListResult;
    };
}

interface OpsTasksFetchCountsSuccessAction extends Action<typeof OPS_TASKS_FETCH_COUNTS_SUCCESS_ACTION_TYPE> {
    payload: {
        counts: OpsTasksCounts;
    };
}

type OpsTasksSaveStartAction = Action<typeof OPS_TASKS_SAVE_START_ACTION_TYPE>;

interface OpsTasksSaveSuccessAction extends Action<typeof OPS_TASKS_SAVE_SUCCESS_ACTION_TYPE> {
    payload: {
        savedTask: OpsTask;
    };
}

interface OpsTasksDeleteStartAction extends Action<typeof OPS_TASKS_DELETE_START_ACTION_TYPE> {
    payload: {
        deletedTaskId: number;
    };
}

interface OpsTasksDeleteSuccessAction extends Action<typeof OPS_TASKS_DELETE_SUCCESS_ACTION_TYPE> {
    payload: {
        deletedTaskId: number;
    };
}

// update_status_start applies the new status optimistically to the row.
interface OpsTasksUpdateStatusStartAction extends Action<typeof OPS_TASKS_UPDATE_STATUS_START_ACTION_TYPE> {
    payload: {
        taskId: number;
        status: OpsTaskStatusId;
    };
}

interface OpsTasksUpdateStatusSuccessAction extends Action<typeof OPS_TASKS_UPDATE_STATUS_SUCCESS_ACTION_TYPE> {
    payload: {
        task: OpsTask;
    };
}

type OpsTasksBulkCompleteStartAction = Action<typeof OPS_TASKS_BULK_COMPLETE_START_ACTION_TYPE>;

type OpsTasksBulkCompleteSuccessAction = Action<typeof OPS_TASKS_BULK_COMPLETE_SUCCESS_ACTION_TYPE>;

interface OpsTasksErrorAction extends Action<typeof OPS_TASKS_ERROR_ACTION_TYPE> {
    payload: {
        error?: string;
    };
}

export type OpsTasksAction =
    | OpsTasksResetAction
    | OpsTasksFetchStartAction
    | OpsTasksFetchSuccessAction
    | OpsTasksFetchCountsSuccessAction
    | OpsTasksSaveStartAction
    | OpsTasksSaveSuccessAction
    | OpsTasksDeleteStartAction
    | OpsTasksDeleteSuccessAction
    | OpsTasksUpdateStatusStartAction
    | OpsTasksUpdateStatusSuccessAction
    | OpsTasksBulkCompleteStartAction
    | OpsTasksBulkCompleteSuccessAction
    | OpsTasksErrorAction;
